import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { PaymentMethodBuilder } from '../../models/builders/payment-method-builder';
import { PaymentMethod } from '../../models/payment-method';

const createPaymentMethodBody = (paymentMethod: PaymentMethod) => (
  {
    name: paymentMethod.name,
    description: paymentMethod.description
  }
);

@Injectable()
export class PaymentMethodApiService {
  private apiUrl: string;

  constructor(
    private httpClient: HttpClient
  ) {
    this.apiUrl = `${environment.apiUrl}payment-methods`;
  }

  getPaymentMethod(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
     .pipe(
       map(PaymentMethodBuilder.fromJson)
    );
  }

  getPaymentMethods() {
    return this.httpClient.get(this.apiUrl).pipe(map(PaymentMethodBuilder.fromJsonList));
  }

  getAuthorizablePaymentMethods() {
    return this.httpClient.get(`${ this.apiUrl }/admin`).pipe(map(PaymentMethodBuilder.fromJsonList));
  }

  createPaymentMethod(paymentMethod: PaymentMethod) {
    return this.httpClient.post(`${this.apiUrl}`, createPaymentMethodBody(paymentMethod)).pipe(
      map(PaymentMethodBuilder.fromJson)
    );
  }

  updatePaymentMethod(paymentMethod: PaymentMethod) {
    return this.httpClient.put(`${ this.apiUrl }/${ paymentMethod.hash }`, createPaymentMethodBody(paymentMethod));
  }

  deletePaymentMethod(paymentMethodHash: string) {
    return this.httpClient.delete(`${ this.apiUrl }/${ paymentMethodHash }`);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/services/api/payment-method-api.service.ts